import { createSlice } from '@reduxjs/toolkit';
import appTypes from './types';
const initialState = {};
const slice = createSlice({
    name: 'APP',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
    // setAppReady(state) {
    //   state.isAppReady = true
    // },
    },
});
export const { reducer, actions } = slice;
export default reducer;
